import { createReducer } from '../lib/createReducer';

const initialState = {
  operationsMetrics: [],
  companiesWithWorkflows: [],
  apiCalls: [],
  workflowOperations: [],
  workflowCompanyUsage: [],
  workflowCompanyUsageError: null
};

export default createReducer(initialState, {
  GET_OPERATION_METRICS_SUCCESS: (state, payload) => ({
    ...state,
    operationsMetrics: payload?.data || []
  }),
  GET_COMPANIES_WITH_WORKFLOWS_SUCCESS: (state, payload) => ({
    ...state,
    companiesWithWorkflows: payload?.data || []
  }),
  GET_API_CALLS_SUCCESS: (state, payload) => ({
    ...state,
    apiCalls: payload?.data || []
  }),
  GET_WORKFLOW_OPERATIONS_SUCCESS: (state, payload) => ({
    ...state,
    workflowOperations: payload?.data || []
  }),
  GET_WORKFLOW_COMPANY_USAGE_SUCCESS: (state, payload) => ({
    ...state,
    workflowCompanyUsage: payload?.data || [],
    workflowCompanyUsageError: null
  }),
  GET_WORKFLOW_COMPANY_USAGE_FAIL: (state, payload) => ({
    ...state,
    workflowCompanyUsageError: payload?.message || 'Failed to load workflow company usage.'
  })
});
